const beep = (freq, dur, type = 'sine') => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    gain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + dur);
    osc.stop(ctx.currentTime + dur);
  } catch (e) {
    console.warn('Audio API not supported or disabled:', e);
  }
};

export const playScoreSound = () => beep(660, 0.08);
export const playUndoSound = () => beep(300, 0.1);
export const playWinSound = () => {
  beep(523, 0.1, 'square');
  setTimeout(() => beep(659, 0.1, 'square'), 120);
  setTimeout(() => beep(784, 0.3, 'square'), 240);
};

export const vibrate = (pattern = [30]) => {
  try {
    navigator.vibrate?.(pattern);
  } catch (e) {
    console.warn('Vibration API not supported:', e);
  }
};